import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import OwlCarousel from 'react-owl-carousel';
import { fetchPromocionesIfNeeded } from "../../../actions/PromocionesActions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class PromocionesConDescuento extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        this.props.fetchPromocionesIfNeeded();
    }

    formatFecha(fecha) {
        // var oldFecha = new Date(fecha);

        var date = fecha.split("-");


        var dia = date[2].substring(0, 2);
        var mes = date[1];
        var anio = date[0];
        var newFecha = dia + "/" + mes + "/" + anio;
        return newFecha;
    }

    render() {
        let productos = [];
        let producto = null;
        let categYproductos = this.props.categorias.allIds.map((idCateg) => {
            let categoria = this.props.categorias.byId.categorias[idCateg];

            let i = 0;
            let productosPromocion = [];
            while (i < this.props.productosPromocion.allIds.length) {
                let productoPromocion = this.props.productosPromocion.byId.productosPromocion[this.props.productosPromocion.allIds[i]];
                let productoPromocionAnt = productoPromocion;
                productos = [];

                while (i < this.props.productosPromocion.allIds.length && productoPromocion.idPromocion == productoPromocionAnt.idPromocion) {
                    producto = this.props.productos.byId.productos[productoPromocion.codProducto] ? this.props.productos.byId.productos[productoPromocion.codProducto] : {};
                    productos.push(
                        <li dangerouslySetInnerHTML={{ __html: `[${producto.codProducto}] ${producto.descripcion}` }}></li>
                    );
                    i++;
                    if (i < this.props.productosPromocion.allIds.length) {
                        productoPromocion = this.props.productosPromocion.byId.productosPromocion[this.props.productosPromocion.allIds[i]];
                    }
                }

                let promocion = this.props.promociones.byId.promociones[productoPromocionAnt.idPromocion] ? this.props.promociones.byId.promociones[productoPromocionAnt.idPromocion] : {};

                if (producto.idCategoria != categoria.id)
                    continue;
                productosPromocion.push(
                    <div className="item">
                        <div className="promo-desc">
                            <h4>{promocion.nombrePromo}</h4>
                            <Row>
                                <Col md={promocion.descuento == "" ? 12 : 5}>
                                    <img className="img-responsive"
                                        // src={process.env.PUBLIC_URL + "/promo-img/" + producto.imgProducto}
                                        //  src={promocion.imgPromo ? process.env.PUBLIC_URL + "/promo-img/" + promocion.imgPromo : process.env.PUBLIC_URL + "/promo-img/img/" + producto.codArticuloWeb + ".png"}
                                        src={promocion.imgPromo ? process.env.PUBLIC_URL + "/promo-img/" + promocion.imgPromo : "https://secure.sig2k.com/webs/myfsrl@sigma.defaultKart/sigkart/3.1/imagen.php?fotoid=" + producto.codArticuloWeb + "&auto=300"}

                                        alt="" />
                                </Col>
                                <Col md={7}>
                                    <ul>
                                        {/*{productos}*/}
                                        <li>{
                                            <span>&nbsp;Vigente desde: {this.formatFecha(promocion.fechaDesde)}</span>}</li>
                                        <li>{
                                            <span>&nbsp;Vigente hasta: {this.formatFecha(promocion.fechaHasta)}</span>}</li>
                                    </ul>
                                </Col>
                            </Row>
                            {
                                promocion.descuento > 0 &&
                                <div>
                                    <h5>{promocion.descuento + "%"}</h5>
                                    <p>de descuento</p>
                                </div>
                            }
                        </div>
                    </div>
                )

            }
            return (
                <div style={{ display: productosPromocion.length > 0 ? "block" : "none" }}>
                    <Row className="promo">
                        <h2 dangerouslySetInnerHTML={{ __html: `¡Descuento en ${categoria.nombreCategoria}!` }}>
                        </h2>
                        <OwlCarousel
                            className="owl-theme"
                            loop={false}
                            margin={50}
                            autoplay={true}
                            autoplayHoverPause={true}
                            autoplayTimeout={7000}
                            autoplaySpeed={3500}
                            responsive={
                                {
                                    0: {
                                        items: 1
                                    },
                                    // breakpoint from 480 up
                                    480: {
                                        items: 1
                                    },
                                    // breakpoint from 768 up
                                    768: {
                                        items: 2
                                    },
                                    // breakpoint from 768 up
                                    991: {
                                        items: 3
                                    }
                                }
                            }
                        >
                            {productosPromocion}
                        </OwlCarousel>
                    </Row>
                </div>
            )

        });

        return (

            <div>
                <div style={{ marginTop: "80px" }}></div>
                {categYproductos}
                <div>
                    <p style={{
                        margin: "0px",
                        textAlign: "left",
                        color: "white",
                        fontFamily: "MyriadPro",
                        fontWeight: "100",
                        fontSize: "9px",
                        marginLeft: "10px"
                    }}>*Imágenes Ilustrativas, pueden no coincider con el producto en promoción</p>
                </div>
            </div>
        )
            ;
    }
}


function mapStateToProps(state) {
    return {
        promociones: state.promociones,
        productos: state.productos,
        categorias: state.categorias,
        productosPromocion: state.productosPromocion,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPromocionesIfNeeded: () => {
            dispatch(fetchPromocionesIfNeeded());
        }
    }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PromocionesConDescuento));



// WEBPACK FOOTER //
// ./src/pages/Promociones/PromocionesSubComponents/PromocionesConDescuento.js